import React, { ReactNode } from "react";

import { ProductEventProps, productAnalytics, trackMixpanel } from "utils";

type AnchorProps = ProductEventProps & {
  children?: ReactNode | null;
  className?: string;
  disabled?: boolean;
  href?: string;
  mixpanelText?: string;
  size?: string;
  target?: string;
  to?: string;
  type?: string;
  onClick?: (e: React.MouseEvent) => void;
};

export const Anchor = ({
  children = null,
  className = "",
  disabled = false,
  href = "",
  mixpanelText,
  productEvent,
  productEventProperties,
  size = "",
  target,
  to,
  type = "default",
  onClick = () => {},
}: AnchorProps) => {
  const classNames = `anchor-${type} ${size} ${disabled ? " disabled" : ""} ${className}`;
  return (
    <a
      href={href || to}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : ""}
      className={classNames}
      onClick={(e: React.MouseEvent) => {
        onClick(e);
        trackMixpanel("ClickLink", {
          linkText: mixpanelText || (typeof children === "string" && children) || "undefined",
          link: href,
        });
        if (productEvent) productAnalytics.track(productEvent, productEventProperties);
        return true;
      }}
    >
      {children}
    </a>
  );
};

export default Anchor;
